export { Route, createRoutes, createRoutes as route, // shorthand
 } from './lib/route-map.js';
export { RequestBodyMethods, RequestMethods } from './lib/request-methods.js';
// Route helpers
export { createDeleteRoute, createDeleteRoute as del, // shorthand
createGetRoute, createGetRoute as get, // shorthand
createHeadRoute, createHeadRoute as head, // shorthand
createOptionsRoute, createOptionsRoute as options, // shorthand
createPatchRoute, createPatchRoute as patch, // shorthand
createPostRoute, createPostRoute as post, // shorthand
createPutRoute, createPutRoute as put, // shorthand
 } from './lib/route-helpers/method.js';
export { createFormRoutes, createFormRoutes as form, // shorthand
 } from './lib/route-helpers/form.js';
export { createResourceRoutes, createResourceRoutes as resource, // shorthand
 } from './lib/route-helpers/resource.js';
export { createResourcesRoutes, createResourcesRoutes as resources, // shorthand
 } from './lib/route-helpers/resources.js';
